import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { Actions, Field, Sort } from './types'

type HeadProps<T> = {
  readonly fields: Field<T>[]
  readonly sort?: Sort<T>
  readonly actions?: Actions<T>
}

export function Head<T extends { [key: string]: any }>(props: HeadProps<T>) {
  const handleSort = (name: keyof T) => () => props.sort?.handleSort && props.sort.handleSort(name)

  const headCells = Object.values(props.fields).map((f) => (
    <TableCell
      style={{
        width: `${100 / Object.keys(props.fields).length}%`,
      }}
      sx={{
        fontWeight: 600,
        background: 'transparent',
        color: 'var(--gray-text)',
        fontSize: '14px',
        borderBottom: '3px solid var(--green-primary)',
        padding: '16px',
      }}
      key={f.name as string}
    >
      {f.sortable ? (
        <TableSortLabel
          active={f.name === props.sort?.name}
          direction={props.sort?.direction || 'asc'}
          onClick={handleSort(f.name)}
          sx={{
            '&.Mui-active': {
              color: 'var(--gray-text)',
              '& .MuiTableSortLabel-icon': {
                color: 'var(--green-primary)',
              },
            },
          }}
        >
          {f.label}
        </TableSortLabel>
      ) : (
        f.label
      )}
    </TableCell>
  ))

  return (
    <TableHead>
      <TableRow>
        {headCells}
        {props.actions && props.actions.actionsColumn && (
          <TableCell
            style={{
              width: `${100 / Object.keys(props.fields).length}%`,
            }}
            sx={{
              fontWeight: 600,
              background: 'transparent',
              color: 'var(--gray-text)',
              fontSize: '14px',
              borderBottom: '3px solid var(--green-primary)',
              padding: '16px',
            }}
          >
            {props.actions.actionsColumn}
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  )
}
